import { render, staticRenderFns } from "./AppOfferCard.vue?vue&type=template&id=5b5a1d46&scoped=true"
import script from "./AppOfferCard.vue?vue&type=script&lang=ts"
export * from "./AppOfferCard.vue?vue&type=script&lang=ts"
import style0 from "./AppOfferCard.vue?vue&type=style&index=0&id=5b5a1d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a1d46",
  null
  
)

export default component.exports